import { render, staticRenderFns } from "./StokBarangGudang.vue?vue&type=template&id=e039bfc2&scoped=true&"
import script from "./StokBarangGudang.vue?vue&type=script&lang=js&"
export * from "./StokBarangGudang.vue?vue&type=script&lang=js&"
import style0 from "./StokBarangGudang.vue?vue&type=style&index=0&id=e039bfc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e039bfc2",
  null
  
)

export default component.exports